import PassportAdminHealthcareReviewTable from "./PassportAdminHealthcareReviewTable";

export default PassportAdminHealthcareReviewTable;
